import { Action, createReducer, on } from '@ngrx/store';

import { IUser } from '../interfaces';
import * as UserActions from './user.actions';

export interface IUserState {
  user?: IUser;
}

export const initialState: IUserState = {
  user: null,
};

// tslint:disable-next-line:typedef
export function userReducer(existingState: IUserState, action: Action) {
  return createReducer(
    initialState,
    on(UserActions.getUserSuccess, (state, { userData }) => ({
      ...state,
      user: userData
    })),
  )(existingState, action);
}

export const user = (state: IUserState) => state.user;
